module.exports = __webpack_public_path__ + "static/img/master.b8c695a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/master.png
// module id = 5ccQ
// module chunks = 1